module.exports = __webpack_public_path__ + "img/iconuser-copy-2.69ace523.svg";